export default {
  title: 'Przenieś witrynę',
  buttons: {
    cancel: 'Anuluj',
    transfer: 'Przenieś',
  },
  fields: {
    target_franchise: {
      label: 'Docelowa franczyza',
      description: 'Wybierz franczyzę, do której ma zostać przeniesiona witryna',
    },
    sync_companies: {
      label: 'Mapowania firm',
      description: 'Przypisz firmy z docelowej franczyzy do firm witryny',
      franchise_company: 'Firma franczyzy',
      storefront_company: 'Firma witryny',
      select_franchise_company: 'Wybierz firmę franczyzy',
      select_storefront_company: 'Wybierz firmę witryny',
      franchise_company_required: 'Firma franczyzy jest wymagana',
      storefront_company_required: 'Firma witryny jest wymagana',
    },
  },
  toasts: {
    failed_to_load_companies: 'Nie udało się załadować firm',
    no_companies_selected: 'Dodaj co najmniej jedno mapowanie firmy',
    failed_to_transfer: 'Nie udało się przenieść witryny',
    transfer_success: 'Witryna przeniesiona pomyślnie',
    franchise_already_connected: 'Docelowa franczyza jest już połączona z witryną',
  },
};
